import { Validators } from '@angular/forms';

import { UserCapacity } from '@enums/user-capacity.enum';
import { parametersStepValidator } from '@forms/create-company-form';
import { BusinessUnit } from '@models/business-unit';
import { CreateCompany } from '@models/create-company';
import { CreateCompanyFormDisplayedForms } from '@shared-forms/create-company-form/create-company-form.component';

import { CreateCompanyAvailableStep, CreateCompanyState } from './create-company-state';

export class CreateCapitalDepositCompanyState extends CreateCompanyState {
  availableSteps: CreateCompanyAvailableStep[] = ['User', 'Company', 'Parameters'];
  companyStepDisplayedForms: CreateCompanyFormDisplayedForms[] = ['company'];

  initForm(businessUnits: BusinessUnit[]): void {
    this.form.initCompanyFromBusinessUnits(businessUnits);
    this.form.companyStep.company.tiimeBusinessOptin.setValue(true);
    this.form.companyStep.company.apeCode.id.addValidators(Validators.required);
    this.form.companyStep.company.legalForm.addValidators(Validators.required);

    this.form.userStep.user.capacity.addValidators(Validators.required);
    this.form.userStep.user.capacity.setValue(UserCapacity.Manager);

    this.form.parametersStep.addValidators(parametersStepValidator());
  }

  toCreateCompany(): CreateCompany {
    const createCompany = this.form.toCreateCompany();
    createCompany.isCapitalDeposit = true;
    return createCompany;
  }
}
